const exportList = {
    path: 'exportList',
    component: resolve => require(['../../../../../pages/admin/my_service_order/exportList'], resolve),
    meta: {
        requireAuth: true
    }
}

export default exportList
